// extracted by mini-css-extract-plugin
export default {"textContainer":"PopulationBasedFundingClickableText_textContainer__xy4kW"};